var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroupDiscussionBro(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F1AB1E;}\n\t.st1{opacity:0.7;fill:#FFFFFF;enable-background:new    ;}\n\t.st2{fill:#263238;}\n\t.st3{fill:#FFFFFF;stroke:#263238;stroke-linecap:round;stroke-linejoin:round;}\n\t.st4{fill:none;stroke:#263238;stroke-linecap:round;stroke-linejoin:round;}\n\t.st5{fill:#263238;stroke:#263238;stroke-linecap:round;stroke-linejoin:round;}\n\t.st6{fill:#FFFFFF;stroke:#263238;stroke-miterlimit:10;}\n\t.st7{fill:#F1AB1E;stroke:#263238;stroke-linecap:round;stroke-linejoin:round;}\n\t.st8{fill:#BDBDBD;stroke:#263238;stroke-linecap:round;stroke-linejoin:round;}\n\t.st9{fill:none;stroke:#878787;stroke-linecap:round;stroke-linejoin:round;}\n\t.st10{fill:#616161;stroke:#263238;stroke-linecap:round;stroke-linejoin:round;}\n\t.st11{fill:#FFFFFF;stroke:#263238;stroke-width:0.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;}\n\t.st12{fill:#636363;stroke:#263238;stroke-linecap:round;stroke-linejoin:round;}\n\t.st13{fill:#D1D1D1;stroke:#263238;stroke-linecap:round;stroke-linejoin:round;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M451.8,238.5c-13.4-27-30-51.9-49.1-73.8c-20.6-23.6-41.7-39.6-68.8-49.9c-18.4-7-37.6-11-56.8-11.8 c-35.9-1.4-65.4,8.4-94.8,33c-31.5,26.4-61,56.2-91.8,83.9c-3.2,2.9-6.4,5.8-9.7,8.6c-53.6,47.1-79.7,130.7-43.4,151h417.3 c0,0,38-2.3,28.6-48.9C476.6,298.1,465.9,267.1,451.8,238.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M451.8,238.5c-13.4-27-30-51.9-49.1-73.8c-20.6-23.6-41.7-39.6-68.8-49.9c-18.4-7-37.6-11-56.8-11.8 c-35.9-1.4-65.4,8.4-94.8,33c-31.5,26.4-61,56.2-91.8,83.9c-3.2,2.9-6.4,5.8-9.7,8.6c-53.6,47.1-79.7,130.7-43.4,151h417.3 c0,0,38-2.3,28.6-48.9C476.6,298.1,465.9,267.1,451.8,238.5z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 411.5,
    y: 300,
    className: "st2",
    width: 31.5,
    height: 42.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "425.4,214.3 425.4,306.4 428.6,303.2 428.6,249.6 438.6,226 428,245.8 427.6,217.2  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "419.1,210.2 400.8,198.6 411.7,210.6 394,206.2 406.6,212.4 385.1,212.4 402.9,215.1 382.1,219.1  398.9,218.5 383.3,225 400.1,222.2 377.8,237.5 404.4,224.6 390.4,238.7 403.2,230.5 394,246.7 407.5,231.1 400.8,245.2  412.7,230.2 412.7,240.6 418.2,228 418.2,235.1 423.7,220.3 423.7,227.7 427.6,217.2 428.6,214.5 416.7,198.3 420.4,208.1  416.7,205.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "416.8,239 395.2,241.7 411.3,244 394.9,251.9 408.5,248.7 391.9,262.3 407.4,253.1 393.8,269.5  406.4,258.3 398.5,273.2 409.8,260.4 402.2,286.3 414.6,259.5 412.7,279.3 417.3,264.7 420.6,283.1 421,262.5 424.8,277.7  424.5,258.5 431.1,266.5 427.3,253.3 431.9,258.8 426.8,244 431.4,249.6 427.8,239 426.9,236.3 407.3,231.4 416.4,236.7  411.6,236.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "416.8,239 395.2,241.7 411.3,244 394.9,251.9 408.5,248.7 391.9,262.3 407.4,253.1 393.8,269.5  406.4,258.3 398.5,273.2 409.8,260.4 402.2,286.3 414.6,259.5 412.7,279.3 417.3,264.7 420.6,283.1 421,262.5 424.8,277.7  424.5,258.5 431.1,266.5 427.3,253.3 431.9,258.8 426.8,244 431.4,249.6 427.8,239 426.9,236.3 407.3,231.4 416.4,236.7  411.6,236.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "436.4,204.7 465,200.6 445.1,209 468.9,213.6 450.5,214.1 476.3,225.8 453.4,219.4 476.3,235.6  456.4,225.6 471.7,241.9 452.8,229.4 471.5,260.1 446.3,230 455.6,254.7 444.7,237.7 446.9,262.3 439.2,236.1 439.6,256.8  433.4,232.1 427.7,244.7 427.9,226.6 424,235.1 425.4,214.3 421.4,223.2 422.4,208.4 422.7,204.7 445.9,191.6 436.2,201.4  442.3,199.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "432.8,199.6 444.4,181.2 432.5,192.2 436.7,174.5 430.6,187.1 430.6,165.6 427.9,183.4 423.9,162.6  424.5,179.4 418.1,163.8 420.8,180.6 405.5,158.3 418.4,184.9 404.3,170.8 412.5,183.7 396.3,174.5 411.9,188 397.9,181.2  412.9,193.2 402.5,193.2 415,198.7 408,198.7 422.6,204.2 415.3,204.2 425.8,208.1 428.5,209.1 444.7,197.2 434.9,200.8  438,197.2  "
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Stage--inject-1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "23.6,400.4 23.6,349.2 30,341.7 478.8,341.7 486.4,350.8 486.4,399.9  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 27.1,
    y1: 349.5,
    x2: 482.1,
    y2: 349.5
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bricks--inject-1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M415.7,136.7h22.2c1.5,0,2.7,1.2,2.7,2.7v11.5c0,1.5-1.2,2.7-2.7,2.7h-22.2c-1.5,0-2.7-1.2-2.7-2.7v-11.5 C413,137.9,414.2,136.7,415.7,136.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M439.6,113.4H451c1.5,0,2.7,1.2,2.7,2.7v3.1c0,1.5-1.2,2.7-2.7,2.7h-11.5c-1.5,0-2.7-1.2-2.7-2.7V116 C437,114.6,438.1,113.4,439.6,113.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M453.9,165.4h4.9c1.5,0,2.7,1.2,2.7,2.7v0.7c0,1.5-1.2,2.7-2.7,2.7h-4.9c-1.5,0-2.7-1.2-2.7-2.7v-0.7 C451.3,166.6,452.5,165.4,453.9,165.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M272.1,269.5h31.9c1.5,0,2.7,1.2,2.7,2.7v10.3c0,1.5-1.2,2.7-2.7,2.7h-31.9c-1.5,0-2.7-1.2-2.7-2.7v-10.3 C269.4,270.7,270.6,269.5,272.1,269.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M325.3,260h6.7c1.5,0,2.7,1.2,2.7,2.7v1.9c0,1.5-1.2,2.7-2.7,2.7h-6.7c-1.5,0-2.7-1.2-2.7-2.7v-1.9 C322.7,261.2,323.8,260,325.3,260z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M283.4,303.6h13.3c1.5,0,2.7,1.2,2.7,2.7v3.1c0,1.5-1.2,2.7-2.7,2.7h-13.3c-1.5,0-2.7-1.2-2.7-2.7v-3.1 C280.8,304.8,282,303.6,283.4,303.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M176.3,261.8h19.9c1.5,0,2.7,1.2,2.7,2.7v6.7c0,1.5-1.2,2.7-2.7,2.7h-19.9c-1.5,0-2.7-1.2-2.7-2.7v-6.7 C173.7,262.9,174.9,261.8,176.3,261.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M138.7,280.9h13.9c1.5,0,2.7,1.2,2.7,2.7v5.5c0,1.5-1.2,2.7-2.7,2.7h-13.9c-1.5,0-2.7-1.2-2.7-2.7v-5.5 C136,282.1,137.2,280.9,138.7,280.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M139.9,260.6h7.9c1.5,0,2.7,1.2,2.7,2.7v2.5c0,1.5-1.2,2.7-2.7,2.7h-7.9c-1.5,0-2.7-1.2-2.7-2.7v-2.5 C137.2,261.8,138.4,260.6,139.9,260.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M68,163h8.5c1.5,0,2.7,1.2,2.7,2.7v1.3c0,1.5-1.2,2.7-2.7,2.7H68c-1.5,0-2.7-1.2-2.7-2.7v-1.3 C65.5,164.2,66.6,163,68,163z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M44.7,129.5H67c1.5,0,2.7,1.2,2.7,2.7v9.7c0,1.5-1.2,2.7-2.7,2.7H44.7c-1.5,0-2.7-1.2-2.7-2.7v-9.7 C42.1,130.7,43.3,129.5,44.7,129.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M80,128.9h10.3c1.5,0,2.7,1.2,2.7,2.7v1.3c0,1.5-1.2,2.7-2.7,2.7H80c-1.5,0-2.7-1.2-2.7-2.7v-1.3 C77.4,130.1,78.6,128.9,80,128.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M63.9,102H73c1.5,0,2.7,1.2,2.7,2.7v1.9c0,1.5-1.2,2.7-2.7,2.7h-9.1c-1.5,0-2.7-1.2-2.7-2.7v-1.9 C61.2,103.2,62.4,102,63.9,102z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M31.5,292.2h7.9c1.5,0,2.7,1.2,2.7,2.7v1.9c0,1.5-1.2,2.7-2.7,2.7h-7.9c-1.5,0-2.7-1.2-2.7-2.7v-1.9 C28.9,293.4,30.1,292.2,31.5,292.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M445.5,277.3h18.1c1.5,0,2.7,1.2,2.7,2.7v10.3c0,1.5-1.2,2.7-2.7,2.7h-18.1c-1.5,0-2.7-1.2-2.7-2.7v-10.3 C443,278.5,444.1,277.3,445.5,277.3z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Speech_Bubble--inject-1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M292.8,111.3h-35.5c-2.3,0-4.2,1.9-4.2,4.2v18.1c0,2.3,1.7,4,4,4.2l-2.1,7.2l9.3-7.2h28.5 c2.3,0,4.2-1.9,4.2-4.2v-18.1C297,113.2,295.1,111.3,292.8,111.3L292.8,111.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M291.3,109.4h-35.5c-2.3,0-4.2,1.9-4.2,4.2v18.1c0,2.3,1.7,4,4,4.2l-2.1,7.2l9.3-7.2h28.5 c2.3,0,4.2-1.9,4.2-4.2v-18.1C295.6,111.3,293.6,109.4,291.3,109.4L291.3,109.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M266.2,122.1c0,0.8-0.7,1.4-1.4,1.4s-1.4-0.7-1.4-1.4s0.7-1.4,1.4-1.4S266.2,121.4,266.2,122.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M274.9,122.1c0,0.8-0.7,1.4-1.4,1.4c-0.7,0-1.4-0.7-1.4-1.4s0.7-1.4,1.4-1.4 C274.3,120.7,274.9,121.4,274.9,122.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M283.7,122.1c0,0.8-0.7,1.4-1.4,1.4c-0.7,0-1.4-0.7-1.4-1.4s0.7-1.4,1.4-1.4 C283,120.7,283.7,121.4,283.7,122.1z"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Board--inject-1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 92.9,
    y: 100,
    className: "st4",
    width: 304.7,
    height: 150.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.9,
    y: 244.7,
    className: "st4",
    width: 304.7,
    height: 5.3
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Podium--inject-1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "112.7,228.4 45.9,228.4 42.2,182.8 116.4,182.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "112.7,231.7 45.9,231.7 42.2,186.5 116.4,186.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 195.9,
    className: "st7",
    width: 62.4,
    height: 148.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.6,
    y: 216.9,
    className: "st4",
    width: 35.9,
    height: 44.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.8,
    y: 331.5,
    className: "st7",
    width: 78.9,
    height: 12.5
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character_6--inject-1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M221.2,117.2c0,0-5.3-1.2-9.2,0.1s-8.1,5.9-7.5,7c0.6,1.1,3.6-0.1,3.6-0.1s-2.8,2.8-2.4,3.2 c0.4,0.4,0.8,0.7,0.8,0.7s-3.5,3.5-3.9,7.7c-0.5,4.2,1.5,6,1.5,6l2.4-1.5c0,0-0.5,3.9,2.4,5.9c2.9,2,3.2,1.1,3.2,1.1 s3.5,4.7,9,5.5s8.7,0.1,10.8-0.9c2.1-1.1,3.7-2.5,3.7-2.5s-0.5,1.7,1.7,0.9s6.2-5.4,6.2-5.4s0.9,1.3,2-0.3 c1.1-1.6,0.1-8.1,0.1-8.1s3.1,0.9,2.4-1.5c-0.7-2.4-3.4-10.2-5.8-12.1c-2.5-1.9-6.2-3.1-6.2-3.1s1.9,0.7,1.3-0.5 c-0.5-1.2-4.7-3.5-8.7-3.5c-4-0.1-5.2,1.2-5.2,1.2s-0.9-1.5-1.5-0.9S221.2,117.2,221.2,117.2L221.2,117.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M214.5,132.4c0,0-1.2,0.4-1,2.1s1.8,4.2,1.8,4.2L214.5,132.4L214.5,132.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M233.6,132.4c0,0,1.5-0.2,1.3,1.9c-0.2,2.1-1.5,4.8-1.5,4.8L233.6,132.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M198.9,215.4c0,0-1.2,13.7,2.2,24.2c3.4,10.6,8.4,22.3,8.6,25.5s-5,15.4-3.6,25.3c1.5,9.9,9.4,29.3,10,33.5 s-1.6,19.4-1.4,21.1c0.2,1.7,3.6,2.2,4.9,2.2s3.2-1.3,3.2-1.3s2.5,0.7,4.7,0.4s2.4-2.5,1.8-4.6c-0.7-2.1-3.1-14.4-3.2-17.1 s5.4-19.5,6.5-29.1c1.3-10.9,1.3-20.1,1.9-24.1c0.6-4,0.9-6.2,0.9-6.2s7-18.7,9.3-28.8c2.3-10.2,1.5-21,1.5-21.8 s-3.3-10.7-3.3-10.7l-41.3-0.3L198.9,215.4L198.9,215.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M226.1,324.6c0-0.3,0.1-0.9,0.1-1.5l-4.1-0.1l-6.2,0.1c0.1,0.3,0.1,0.6,0.2,0.8c0.6,4.2-1.6,19.4-1.4,21.1 c0.2,1.7,3.6,2.2,4.9,2.2s3.2-1.3,3.2-1.3s2.5,0.7,4.7,0.4s2.4-2.5,1.8-4.6C228.6,339.6,226.3,327.3,226.1,324.6L226.1,324.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M229.3,341.7c0,0-1.5,0.4-3.2,0.6c-1.7,0.2-3.5-0.5-3.5-0.5s0.9,1,0.9,1.9s-0.7,2.3-0.7,2.3s3.7,0.7,5.4,0.1 C229.9,345.3,230.1,343.1,229.3,341.7L229.3,341.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M223.1,341.8l-8.2-0.1c-0.1,1.7-0.3,3-0.2,3.4c0.2,1.7,3.6,2.2,4.9,2.2s3.2-1.3,3.2-1.3 C223.7,344.6,223.1,341.8,223.1,341.8L223.1,341.8z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "222.1,323 222.3,329.2 223.1,341.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M223.7,233.1c0.1-3.9,0.1-6.6,0.1-6.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M221.9,308.8c0.3-15.9,1-45.3,1.1-47.1c0.1-1.6,0.4-15.7,0.7-25.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M221.7,318.8c0,0,0.1-2.7,0.1-7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "217.8,222.7 224,225.6 228.6,222.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M213.6,154.7c0,0,8-2.1,12.1-1.9c4.2,0.2,7.5,1.7,7.5,1.7s1.9,8.2,2.4,17.9c0.5,9.8-0.8,30.8-1.3,34 s-0.7,5-0.7,5s-7.8-4.3-10.6-4.4c-2.8-0.1-8.6,2.1-8.6,2.1s-2.3-15.5-2.6-26s0.6-25.5,0.6-25.5L213.6,154.7z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 217.6,
    y1: 198.9,
    x2: 228.6,
    y2: 190.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 231.6,
    y1: 184.3,
    x2: 226.5,
    y2: 188.8
  })), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M218.4,146l-1.1,8.1c0,0,1.9,5,7.2,5.2s7.9-5.5,7.9-5.5l-2-8.4L218.4,146L218.4,146z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "219.3,147 218.2,152.8 224.4,149.2  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M222.1,123.4c0,0-2.3,0.2-4.7,2c-2.4,1.8-2.2,5.3-2.1,7.9c0.1,2.6,0.7,9.6,1.7,11.4c1,1.8,4.8,4.8,7,4.8 c2.2,0.1,7.2-3.2,8-6c0.9-2.8,2.1-10,1.3-14.2c-0.7-4.2-5-5.2-5-5.2s0.1,1.5-0.5,1.2C227.2,125,222.1,123.4,222.1,123.4 L222.1,123.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M222.7,138.3c0,0-0.1,0.9,0.2,1.1c0.3,0.3,1.1,0.3,1.7,0.1s0.6-1.3,0.6-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M219.6,141.1c0,0,4.5,0.9,8.5-0.4c0,0-1.3,2.8-3.9,3.5C221.7,145,219.6,141.1,219.6,141.1L219.6,141.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M217,131.7c0,0,1.7-1.3,3.5-0.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M227.8,131.4c0,0,2.3,0.1,2.9,0.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M220.5,134.9c0,0.7-0.3,1.1-0.6,1.1c-0.3,0-0.6-0.5-0.6-1.1c0-0.6,0.3-1.1,0.6-1.1 C220.2,133.8,220.5,134.2,220.5,134.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M227.9,134.9c0,0.7-0.3,1.1-0.6,1.1c-0.3,0-0.6-0.5-0.6-1.1c0-0.6,0.3-1.1,0.6-1.1 C227.6,133.8,227.9,134.2,227.9,134.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M214.6,133.4l0.7,3.6c0,0,3.9,0.4,7-0.5l0.7-3.7C223.1,132.8,217.8,131.3,214.6,133.4L214.6,133.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M233.3,133.4l-0.7,3.6c0,0-3.9,0.4-7-0.5l-0.7-3.7C224.9,132.8,230.2,131.3,233.3,133.4L233.3,133.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M223.1,132.8c0,0,1.4-0.1,1.7,0"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M217.6,153.3c0,0-6.2,1.6-10,2.3c-3.8,0.7-6.6,1.5-7.2,2.6c-0.6,1.1-8.6,28.8-8,30.9c0.5,2.1,2,2.9,4.3,3.9 c2.3,1,4.2,1.3,4.2,1.3s-5.3,22.7-5,23.6c0.3,0.9,4.7,5.3,11.2,5.6c6.4,0.3,8.8,0,9.2-5.8c0.3-5.8-1.7-22.4-1.7-22.4 s-0.7-10.4-0.7-18.9S217.6,153.3,217.6,153.3L217.6,153.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M206.3,163.2c0,0-3.7,12.7-4.2,16.4c-0.6,3.7-1.2,12.9-1.2,12.9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "224.4,158.6 219.9,157.7 221.1,154.6 224.6,155.3  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.2,
    y: 157.4,
    transform: "matrix(0.1935 -0.9811 0.9811 0.1935 22.3445 346.4376)",
    className: "st2",
    width: 3.3,
    height: 4.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "220.7,175.2 217.1,174.4 219.3,160.9 223.7,161.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.9,
    y: 155.9,
    transform: "matrix(0.1935 -0.9811 0.9811 0.1935 23.9744 345.6169)",
    className: "st11",
    width: 0.5,
    height: 4.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M207,177.6l5.3-3.6c0,0,5.2-11.8,5.6-12.2s5.6,0.8,6,0.9c0.3,0.2,0.5,0.6,0.5,1.1c0,0.5-0.2,1.3-0.2,1.3 s-0.1,1.1-0.1,1.4c-0.1,0.3-0.3,1.4-0.3,1.7c0,0.3-0.2,1.1-0.2,1.1s1.4,0.6,2,1.4c0.6,0.8,0.3,1.1-0.1,1.1s-1.3-0.4-1.7-0.4 s-3.5-0.5-4.3-0.3s-0.9,1.6-1.9,3c-0.9,1.4-2.7,2.5-2.7,2.5l-6,8.8L207,177.6L207,177.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M223.6,169.1c0,0-1.8-0.2-2.6-0.3c-0.8-0.1-2.5-0.7-3.1-0.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M217.6,166.5c0.1,0,4.3,0.5,5.1,0.7s1.1,0.3,1.1,0.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M224.1,165.4c0,0-3.4-0.7-4.3-1s-1.8-0.3-2.1,0"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M208,176.4l2.7,9.4c0,0-7.3,11.4-10.8,12.7c-3.4,1.3-6.7,0.7-7.6-1.9s-1.2-6.9,0.2-8.8S208,176.4,208,176.4 L208,176.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M253.9,179.4l2.6-6.4c0,0,0.9-4.2,1.4-5.2c0.5-1.1,6-2.7,6.4-2.9c0.4-0.1,2.7-2.3,3.1-0.8 c0.3,1.5,0.3,1.7-0.8,2.3c-1.1,0.6-3.3,1.9-3.3,1.9s7.5-0.7,8-0.7c0.5,0,5.1-0.3,4.2,1.5c-0.8,1.9-2.7,4.2-4.2,5.1 c-1.5,0.8-11.2,3.3-11.2,3.3l-2.9,5.6L253.9,179.4L253.9,179.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M275.8,168.3c0,0-1.5-4.3-2-4s-0.5,0.6-0.3,1.3c0.2,0.7,1.1,3.3,1.1,3.5C274.6,169.1,275.7,170,275.8,168.3 L275.8,168.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M273.9,171.7c0,0,1.6-1.3,1.7-2.6c0.1-1.3,0.3-3.3,0-4c-0.3-0.8-1.3,0.1-1.1,0.5S273.9,170.9,273.9,171.7 L273.9,171.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M271.5,174.2c0,0,2.2-2.3,2.3-2.6s1.3-6.2,0.7-6.1s-1.4,1.3-1.6,2.3C272.8,168.9,271.5,174.2,271.5,174.2 L271.5,174.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M259.5,175.1c0,0,1.2-1.6,2.3-2.1c1.1-0.5,8.3-0.7,8.3-0.7s2.6-6.2,2.9-5.1c0.3,1.1-1.2,6.6-1.7,7 c-0.5,0.5-7.7,2.6-9.2,2.9"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M232.4,153.8c0,0,2.1,14.7,2,28.3c-0.1,13.7-4.2,31.6-4.4,34.7c-0.2,3.1-0.3,5.4,3.5,6.8s7.4-0.5,10.8-2.7 c3.5-2.3,4.2-4.2,4.2-4.2l-4.8-18.7c0,0,5.1,4,8.2-0.3c3.1-4.2,7.2-14.6,7.2-14.6l-4.4-5.2l-5.1,5.1c0,0-3.1-24.6-3.9-25.4 c-0.8-0.8-1.9-0.9-2.4-0.9C242.8,156.7,232.4,153.8,232.4,153.8L232.4,153.8z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 249.6,
    y1: 183.1,
    x2: 245.5,
    y2: 186.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M242.2,169.7c1,5,2.3,12.1,2.3,15.1c-0.1,4.8-0.8,13.3-0.8,13.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M241.1,164.4c0,0,0.3,1.1,0.6,2.8"
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character_5--inject-1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M466.1,400.2l-3.8-27v-18h8.9c0,0,1.9,2.7,2.5,6.8c0.5,3.7,3.1,31.1,3.7,38.2L466.1,400.2L466.1,400.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M398.5,400.2c0.7-7,3.3-34.5,3.7-38.2c0.5-4.2,2.5-6.8,2.5-6.8h8.9v18l-3.8,27L398.5,400.2L398.5,400.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M472.2,363.5c-1.9,3.5-4.4,4-3.9,4.7c0.5,0.7,2.5,3,1.1,5.2s-3.9,4.2-4.4,4.7c-0.5,0.5-2.7,16.8-3.5,22.1 h-46.4c-0.7-5.3-3-21.6-3.5-22.1c-0.5-0.5-3-2.5-4.4-4.7c-1.4-2.3,0.5-4.5,1.1-5.2c0.5-0.7-1.9-1.2-3.9-4.7 c-1.9-3.5,0.3-4.4,0.3-6.3s-1.7-3-0.9-5.2s4.2-1.4,5.2-1.2c1.1,0.2,1.2,0.3,5-0.5s14.3-6,14.3-6l4.7-0.3v-0.7l5,0.3l5-0.3v0.7 l4.7,0.3c0,0,10.5,5,14.3,6c3.9,0.9,4,0.7,5,0.5c1.1-0.2,4.4-1.1,5.2,1.2c0.9,2.3-0.9,3.3-0.9,5.2S474,359.9,472.2,363.5 L472.2,363.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M414.2,400.2l-0.9-26.4c24,4.1,49.7,0,49.7,0l-0.7,26.4H414.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M427.6,308.1c0,0-1.9,3.1-2.1,5.3c-0.1,2.3-0.1,3.8-0.8,4.5c-0.7,0.7-1.9,0.8-1.2,1.9 c0.6,1.1,1.3,1.9,1.3,1.9s0.9,3.7,1.7,5.3s1,3.9,1.7,4.5c0.6,0.6,2.1,0.7,2.1,0.7l0.6,4.6l4.3-5.4l-4.2-25.8L427.6,308.1 L427.6,308.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M441.9,300c0,0,4.7-0.5,8.7,6.1c4,6.6,3.1,15.6,1.2,19.9c-1.9,4.2-6,9.3-11,10.1c-5,0.8-10.4-2.1-13.6-11.4 c-3.3-9.3,0.5-19.7,3.5-22.3C433.7,299.7,438.4,298.5,441.9,300L441.9,300z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M443.9,313.9c0,0,11.8,11.2,10.7,21.5c-1.1,10.4-6.4,9.6-5.8,17.3c0.7,7.6,6,9.8,5.2,14.8 s-3.4,8.6-6.7,10.2s-5.6,1.7-5.6,1.7l0.6-4c0,0-2.9,3.9-7,3.1c-4.1-0.8-6.6-3.9-7.3-6.1l-0.8-2.3c0,0,2.7,0.3,3.5-3.4 c0.8-3.7-2.9-5.5-4.2-8.7c-1.3-3.2-2.9-10.1-0.3-17.1c2.6-7,7.5-9.2,9-15.9c1.5-6.7,1.7-11.8,4.2-13.3 C441.9,310.2,443.9,313.9,443.9,313.9L443.9,313.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M442.7,373.3c0,0,3.2-1.7,1.2-10.1c-2-8.4-6.6-8.1-3.5-17.5c3.1-9.5,7.3-13.9,6.1-20.9 c-1.2-7-4.9-10.7-4.9-10.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M432.5,376.3c0,0,4.4,0,3.5-6.6s-7.5-5.5-9.6-11.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M439,315.5c0,0,2.9,4.6-0.3,14.8s-10,12.7-9.5,20.9c0.5,8.2,4.1,10.6,4.1,10.6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M441.9,301.7c0,0,0.6,4.6-0.6,8.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M437.3,312.2c0,0-6.1,0.1-9.8-1.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M427.7,322.4c0,0,4.9,0.9,7.6-2.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M451.5,310.1c0,0-3.2,4.2-7.6,3.9"
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character_4--inject-1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M389.2,400.2c-0.9-8.6-4.5-43-4.5-44.9c0-2.3-4.2-3.3-7-5c-2.8-1.9-15.5-10.4-15.5-10.4l-13.5-0.4l-13.5,0.4 c0,0-12.8,8.6-15.5,10.4c-2.8,1.9-7,2.8-7,5c0,2-3.7,36.3-4.5,44.9H389.2L389.2,400.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M315.9,356.2c0,0,5,12.2,7.3,15.4"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 316.8,
    y1: 365.9,
    x2: 320.6,
    y2: 371.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 380.2,
    y1: 359.5,
    x2: 373.9,
    y2: 372.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 378.7,
    y1: 366.9,
    x2: 375.8,
    y2: 371.4
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "340.4,325.2 339.4,337.6 359.6,337.6 357.4,325.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M336.5,313.4c0,0-3.4-1.1-2.9,3.4c0.6,4.5,5.1,7.2,5.1,7.2L336.5,313.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M362.2,313.4c0,0,3.4-1.1,2.9,3.4c-0.5,4.5-5.1,7.2-5.1,7.2L362.2,313.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M363.5,305.2c-0.1-1-3.9-6.2-5.8-7.2c-2-1-3.9-2.1-6.1,0.9c0,0-0.1-0.1-0.2-0.1c0.1-0.3,0.1-0.5,0.1-0.5 s-1.3-3.8-3.5-4.8c-2.3-0.9-6.8,0.6-8.2,3.9c0,0.1-0.1,0.1-0.1,0.2c-1.6,1.2-3.1,3-3.9,5.9c-1.7,5.6-1,6.1-0.4,6.5s-0.1,4.6,0.6,8 c0.7,3.3,3.3,9,8.6,11.4c5.4,2.4,10.4,0.4,11.6-0.4c1.3-0.9,6.2-8.8,6.6-11.4s-1.1-8.8-1.1-8.8S363.6,306.2,363.5,305.2 L363.5,305.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "335.3,334.5 332.4,341.9 364.5,341.6 360.9,334.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M375.1,400.2l1.1-26.8c-27,4.2-55.6,0-55.6,0l0.8,26.8H375.1z"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character_3--inject-1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M291.6,400.2c0.8-8.6,3.9-43,3.9-44.9c0-2.3-4.2-3.3-7-5c-2.7-1.8-15.5-10.4-15.5-10.4l-13.5-0.4l-13.5,0.4 c0,0-12.8,8.6-15.5,10.4c-2.8,1.9-7,2.8-7,5c0,2,1.8,36.3,2.3,44.9H291.6L291.6,400.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M226.8,356.2c0,0,5,12.2,7.3,15.4"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 227.6,
    y1: 365.9,
    x2: 231.4,
    y2: 371.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 291,
    y1: 359.5,
    x2: 284.7,
    y2: 372.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 289.5,
    y1: 366.9,
    x2: 286.7,
    y2: 371.4
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M285.9,400.2l1.1-26.8c-27,4.2-55.6,0-55.6,0l0.8,26.8H285.9L285.9,400.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M257.5,295.2c0,0-8.2-0.7-10.2,4.1c-1.9,4.8-6.6,27.6-8.5,32.5c-1.9,4.8-0.3,9.4,4.1,11.6 c4.4,2.2,25,2.4,28.3,2.2c3.4-0.3,8.5-2.7,9.4-5.1c1-2.4,0.5-8.7-1.2-11.4s-3.4-15-6.3-23.5C270.3,297.1,266.4,290.1,257.5,295.2 L257.5,295.2z"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character_2--inject-1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M214.2,400.2c-0.8-7.4-4.3-37.6-5.8-39.8c-1.7-2.5-20-14.7-20-14.7l-14.5-0.6l-14.5,0.6 c0,0-18.3,12.2-20,14.7c-1.5,2.2-5,32.5-5.8,39.8H214.2L214.2,400.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M154.9,369.7c0,0,11.9,5.4,13.8,5.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 166.8,
    y1: 371.7,
    x2: 174.9,
    y2: 375.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M204.7,367.2c0,0-4.6,6.2-6,7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M144.1,367.8c0,0,1.6,6.2,3.2,7.7"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "165.4,331 164.3,342.5 184.6,342.5 182.4,331.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M161.5,320.2c0,0-3.4-1.1-2.9,3.1c0.6,4.2,5.1,6.6,5.1,6.6L161.5,320.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M187.1,320.2c0,0,3.4-1.1,2.9,3.1c-0.6,4.2-5.1,6.6-5.1,6.6L187.1,320.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "160.9,340.8 157.4,346.4 189.5,346.1 186.6,341  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M200,400.2l1.1-24.8c-27,3.9-55.6,0-55.6,0l0.8,24.8H200L200,400.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M181.2,303.8c0,0-5.6-2.1-10.4-1.2c-4.8,0.9-8.6,5.2-10,9.6c-1.5,4.3,0.1,9.5,0.1,10.1c0,0.6,1.4,5.8,2.2,7.6 c0.8,1.7,4.7,6.6,4.7,6.6h12.1c0,0,4.8-6.5,5.8-7.8c0.9-1.3,2.3-7.2,2.5-9.8c0.3-2.6-1.5-10-3.3-12.2 C183.2,304.4,181.2,303.8,181.2,303.8L181.2,303.8z"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character_1--inject-1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M55.4,400.2l3.8-27v-18h-8.9c0,0-1.9,2.7-2.5,6.8c-0.5,3.7-3.1,31.1-3.7,38.2L55.4,400.2L55.4,400.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M122.9,400.2c-0.7-7-3.3-34.5-3.7-38.2c-0.5-4.2-2.5-6.8-2.5-6.8h-8.9v18l3.8,27L122.9,400.2L122.9,400.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M59.9,400.2h46.4c0.7-4.7,2.5-17.9,3.2-21.3l7.2-23.6l-5.7-3.3c-0.7-0.1-2.1-1.3-3.9-1.7 c-3.9-0.9-14.3-6-14.3-6l-4.7-0.3v-0.7l-5,0.3l-5-0.3v0.7l-4.7,0.3c0,0-10.5,5-14.3,6c-3.9,0.9-7.8,5.2-8.9,5l6.3,22.9 C57,378.5,59.2,394.9,59.9,400.2L59.9,400.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M107.3,400.2l0.9-26.4c-24,4.1-49.7,0-49.7,0l0.7,26.4H107.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M97.9,329c-1.4-8.2-0.8-15.8-3.3-21.8c-0.3-0.8-0.9-1.4-1.7-2c-0.7-1.3-1.4-2.3-2.1-2.9 c-3.1-2.6-7.6-3.9-11.2-2.3c0,0-3.7-0.3-7.4,4.2c-0.1,0.1-0.3,0.2-0.3,0.3c0,0-6.2,9-5.4,16.1c0.8,7.1,0.3,18-1.9,22.6 c-2.2,4.6-5.4,7-5.4,7s4.8,5.3,6.8,11.9c1.9,6.6,7.9,19.4,15.5,19.7c3,0.1,5.9-1.6,8.4-4.3c0.2-1.7,0.3-3.9,0.3-6.2 c0-5.2-0.4-9.4-0.4-9.4s2.6,5.4,2.4,9.8c-0.1,1.3-0.3,2.6-0.7,3.8c3-4.1,5.2-9.6,5.7-14.6c1.1-10.4,6.2-12,6.2-12 S99.2,337.2,97.9,329L97.9,329z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M78.4,366.2c-0.1,1.5-0.4,2.9-0.7,4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M68.6,320.3c0,0,0.5,12.3,4.4,18.6c3,4.9,5.6,16.6,5.4,25.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M70.8,350.1c0.3,4.6-1.6,7.1-4,7.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M68.1,329.5c0,0-0.8,7.4,1.7,15.3c0.3,1,0.5,1.9,0.7,2.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M90.9,351.4c1,1,2.2,1.5,3.3,1.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M94.9,318.1c0,0-4.4,13.9-6.2,21c-1,3.7-0.5,7.4,0.8,10"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M81.4,345.9c-0.1,1.2-0.2,2.4-0.2,3.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M86.4,324.4c0,0-3.4,9.1-4.7,19.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M92.9,305.2c0,0-2.9-1.1-4.6,3.6"
  }))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Line--inject-1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 14.6,
    y1: 400.2,
    x2: 495,
    y2: 400.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupDiscussionBro);
export default __webpack_public_path__ + "static/media/Group-discussion-bro.17a82633b829df18a5851cf3ea3d522b.svg";
export { ForwardRef as ReactComponent };